import React from 'react';
import { useTranslation } from 'react-i18next';
import WorkTogether from '../components/WorkTogether';
import PageSeparator from '../components/PageSeparator';

const About = () => {
  const { t } = useTranslation();

  return (
    <main className="text-gray-900">
      {/* Hero Section - Full viewport height */}
      <section className="min-h-screen flex items-center pt-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8">{t('about_us')}</h1>
            <div className="prose prose-lg max-w-none">
              <p className="text-lg md:text-xl leading-relaxed">
                {t('about_description')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center">{t('our_mission')}</h2>
            <div className="prose prose-lg max-w-none">
              <p className="text-lg md:text-xl leading-relaxed text-center">
                {t('mission_description')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center">{t('our_team')}</h2>
            <div className="prose prose-lg max-w-none">
              <p className="text-lg md:text-xl leading-relaxed text-center">
                {t('team_description')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Work Together Section */}
      <WorkTogether />
      <PageSeparator />
    </main>
  );
};

export default About; 